<script>
    import PromptEditHeader from '@/components/page-chat-gpt-edit/prompt-edit/PromptEditHeader.vue';
    import PromptEditData from '@/components/page-chat-gpt-edit/prompt-edit/PromptEditData.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_PROMPT_EDIT}
        },
        components: {
            PromptEditHeader: PromptEditHeader,
            PromptEditData: PromptEditData,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <PromptEditHeader />
        <hr class="hr_light_98">
        <PromptEditData />
    </div>
</template>